import React, { useState, useEffect } from 'react'
import { Form, Button, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import FormContainer from '../components/FormContainer'
import CheckoutSteps from '../components/CheckoutSteps'
import { savePaymentMethod } from '../actions/cartActions'
import { getStripePublishableKey } from '../actions/orderActions'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

function PaymentScreen({ history }) {

    const cart = useSelector(state => state.cart)
    const { shippingAddress } = cart

    const dispatch = useDispatch()

    const [paymentMethod, setPaymentMethod] = useState('Stripe')

    const stripePublishableKey = useSelector(state => state.stripePublishableKey)
    const { publishableKey } = stripePublishableKey

    const [stripePromise, setStripePromise] = useState(null)

    if (!shippingAddress.address) {
        history.push('/shipping')
    }

    useEffect(() => {
        dispatch(savePaymentMethod(paymentMethod))
        history.push('/placeorder')
    }, [dispatch, history, paymentMethod])

    return (
        <FormContainer>
            <CheckoutSteps step1 step2 step3 />
            {/* Payment method selection is now handled implicitly by redirecting to PlaceOrderScreen */}
        </FormContainer>
    )
}

export default PaymentScreen
